(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["miya-bestsellers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Impede que o clique no botão "Adicionar" também dispare a
    // navegação do link do card (o botão fica visualmente dentro
    // do <a>, mas envia um <form> separado via atributo form=).
    document.querySelectorAll('.miya-bestsellers .mk-product-add-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    // Adiciona ao carrinho via fetch (/cart/add.js) pedindo também a
    // seção "cart-drawer" renderizada (?sections=cart-drawer). O tema
    // (cart.min.js) expõe <m-cart-drawer>.renderContents(json) feito
    // exatamente pra isso: atualiza o conteúdo do drawer e abre ele
    // sozinho. Também emitimos o evento pub/sub próprio do tema pra
    // qualquer outro listener (ex: contador do ícone do carrinho) se
    // atualizar do mesmo jeito que uma compra normal faria.
    document.querySelectorAll('.miya-bestsellers .mk-hidden-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = document.querySelector('.mk-product-add-btn[form="' + form.id + '"]');
        var span = btn ? btn.querySelector('span') : null;
        var original = span ? span.textContent : null;

        if (btn) btn.disabled = true;

        var formData = new FormData(form);
        formData.append('sections', 'cart-drawer');

        fetch(form.action + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (span) span.textContent = 'Adicionado!';
            if (btn) btn.classList.add('is-added');

            var cartDrawer = document.querySelector('m-cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
              cartDrawer.renderContents(data);
            }
            if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
              window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, Object.assign({}, data, { source: 'miya-bestsellers' }));
            }
          })
          .catch(function (err) {
            console.error('Falha ao adicionar ao carrinho', err);
          })
          .finally(function () {
            if (btn) btn.disabled = false;
            setTimeout(function () {
              if (span && original) span.textContent = original;
              if (btn) btn.classList.remove('is-added');
            }, 1800);
          });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miya-features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var track = document.querySelector('.miya-features .mk-feat-grid');
    var prevBtn = document.querySelector('.miya-features .mk-feat-nav-prev');
    var nextBtn = document.querySelector('.miya-features .mk-feat-nav-next');
    if (!track || !prevBtn || !nextBtn) return;

    function scrollByItem(dir) {
      var item = track.querySelector('.mk-feat-item');
      if (!item) return;
      var amount = item.getBoundingClientRect().width + 1; // + gap
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () { scrollByItem(-1); });
    nextBtn.addEventListener('click', function () { scrollByItem(1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miya-product-certs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var tracks = document.querySelectorAll('.mk-cert-grid');
    tracks.forEach(function(track) {
      var section = track.closest('.mk-cert-strip');
      var prevBtn = section.querySelector('.mk-cert-nav-prev');
      var nextBtn = section.querySelector('.mk-cert-nav-next');
      if (!prevBtn || !nextBtn) return;

      function updateButtons() {
        if (track.scrollLeft <= 5) {
          prevBtn.disabled = true;
        } else {
          prevBtn.disabled = false;
        }
        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 5) {
          nextBtn.disabled = true;
        } else {
          nextBtn.disabled = false;
        }
      }

      function scrollByItem(dir) {
        var item = track.querySelector('.mk-cert-item');
        if (!item) return;
        var amount = item.getBoundingClientRect().width + 16; // + gap
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      prevBtn.addEventListener('click', function () { scrollByItem(-1); });
      nextBtn.addEventListener('click', function () { scrollByItem(1); });
      track.addEventListener('scroll', updateButtons, { passive: true });
      
      // Inicia com os botões atualizados
      updateButtons();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
